module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-8.jpg?09a02410ea960a5a03eea09fa3cd46b8";